import React from "react";
import { Modal } from "react-bootstrap";

export default function FullScreenModal(props) {
    return <Modal backdrop="static" show={props.show} onHide={() => props.setShow(false)} dialogClassName="modal-98w" aria-labelledby="example-custom-modal-styling-title">
        <Modal.Body className="h-vh-50px overflow-auto p-16">
            {props.children}
        </Modal.Body>
    </Modal>
}